module.exports = __webpack_public_path__ + "img/icono_emitir_certificados.2bbfcc8f.png";